document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mv-cfx-extras .cfxe-ssr-reviews').forEach(root => {
    const reviews = [...root.querySelectorAll('.jdgm-ssr-reviews__list > .jdgm-rev')];
    root.querySelectorAll('.jdgm-rev__body p').forEach(paragraph => {
      for (const edge of ['firstChild', 'lastChild']) {
        while (paragraph[edge]) {
          const node = paragraph[edge];
          if (node.nodeName !== 'BR' && (node.nodeType !== Node.TEXT_NODE || node.textContent.trim())) break;
          node.remove();
        }
      }
    });
    root.querySelectorAll('img[data-src]').forEach(image => {
      const link = image.closest('.jdgm-rev__pic-link');
      const finishLoading = () => {
        link?.classList.remove('jdgm--loading');
        if (!image.naturalWidth && link) link.style.display = 'none';
      };
      image.addEventListener('load', finishLoading, { once: true });
      image.addEventListener('error', finishLoading, { once: true });
      image.loading = 'lazy';
      image.src = image.dataset.src;
      if (image.complete) finishLoading();
    });

    const pageSize = 5;
    if (reviews.length <= pageSize) return;

    const pages = Math.ceil(reviews.length / pageSize);
    const nav = document.createElement('div');
    nav.className = 'cfxe-review-dots';
    nav.setAttribute('role', 'navigation');
    nav.setAttribute('aria-label', 'Review pages');

    const buttons = Array.from({ length: pages }, (_, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cfxe-ssr-dot';
      button.setAttribute('aria-label', `Show review page ${index + 1}`);
      button.addEventListener('click', () => showPage(index, true));
      nav.append(button);
      return button;
    });

    function showPage(page, scroll) {
      reviews.forEach((review, index) => {
        review.hidden = Math.floor(index / pageSize) !== page;
      });
      buttons.forEach((button, index) => {
        const active = index === page;
        button.classList.toggle('cfxe-active', active);
        if (active) button.setAttribute('aria-current', 'page');
        else button.removeAttribute('aria-current');
      });
      if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    root.append(nav);
    showPage(0, false);
  });
});
